<template>
  <div class="databases-page">
    <div class="databases-page__container">
      <div class="databases-header">
        <span class="databases-title">ACTIVE DATABASES</span>
      </div>
      <div class="databases-content">
        <nb-table
          id="activeListTable"
          :data="fillTableActive"
          :border="true"
          :stripe="true"
          :responsive="true"
        >
          <nb-table-column
            prop="c_navdbType"
            width="100"
            label="Database Type"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_databaseIndicator"
            width="120"
            label="Database Identifier"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_formattedAirac"
            width="100"
            label="AIRAC Cycle"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_version"
            width="80"
            label="Version"
          ></nb-table-column>
          <nb-table-column
            prop="c_startDate"
            width="170"
            label="Effectivity Start Date"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_stopDate"
            width="170"
            label="Effectivity End Date"
            sortable
          ></nb-table-column>
          <nb-table-column label="Database" width="200" align="center">
            <template slot-scope="scope">
              <nb-button
                @click="handleClick(fillTableActive, scope.row)"
                type="text"
                name="downloadDatabaseButton"
                :loading="scope.row.loadingStatus"
                >DOWNLOAD Database</nb-button
              >
            </template>
          </nb-table-column>
          <nb-table-column label="Extra Files" width="120" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.extraFileName === ''">
                <span>N/A</span>
              </div>
              <div v-else>
                <nb-button
                  @click="downloadExtraFile(fillTableActive, scope.row)"
                  type="text"
                  name="downloadExtraButton"
                  :loading="scope.row.loadingStatus"
                >
                  DOWNLOAD Extra</nb-button
                >
              </div>
            </template>
          </nb-table-column>
          <nb-table-column label="CRC File" width="130" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.sha256fileName === ''">
                <span>N/A</span>
              </div>
              <div v-else>
                <nb-button
                  @click="downloadSha256(fillTableActive, scope.row)"
                  type="text"
                  name="downloadSha256"
                  :loading="scope.row.loadingStatus"
                >
                  CRC File</nb-button
                >
              </div>
            </template>
          </nb-table-column>
          <nb-table-column
            prop="publicationDate"
            width="200"
            label="Publication Date"
          ></nb-table-column>
          <nb-table-column
            prop="c_remarks"
            width="250"
            label="Remarks"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_dbSize"
            width="150"
            label="DB Size"
            sortable
          ></nb-table-column>
        </nb-table>
      </div>

      <div class="databases-header">
        <span class="databases-title">INACTIVE DATABASES</span>
      </div>
      <div class="databases-content">
        <nb-table
          id="inactiveListTable"
          :data="fillTablePending"
          :border="true"
          :stripe="true"
          :responsive="true"
        >
          <nb-table-column
            prop="c_navdbType"
            width="100"
            label="Database Type"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_databaseIndicator"
            width="170"
            label="Database Identifier"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_formattedAirac"
            width="150"
            label="AIRAC Cycle"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_version"
            width="100"
            label="Version"
          ></nb-table-column>
          <nb-table-column
            prop="c_startDate"
            width="170"
            label="Effectivity Start Date"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_stopDate"
            width="170"
            label="Effectivity End Date"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_deliveryStatus"
            width="150"
            label="Database Status"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_remarks"
            width="250"
            label="Remarks"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="c_dbSize"
            width="150"
            label="DB Size"
            sortable
          ></nb-table-column>
        </nb-table>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Component from "vue-class-component";
import router from "@/router/router";
import { mapState, mapGetters } from "vuex";
import store from "@/store/store";
import {
  fetchList,
  storeData,
  downloadDatabase,
  downloadExtraFile,
  downloadSha256
} from "../API/APIFunctions.js";
import {
  Icon,
  Form,
  FormItem,
  Button,
  Input,
  Separator,
  WelcomePage
} from "@navblue/navblue-ui";

@Component({
  components: {
    NbIcon: Icon,
    NbForm: Form,
    NbFormItem: FormItem,
    NbButton: Button,
    NbInput: Input,
    NbSeparator: Separator,
    NbWelcomePage: WelcomePage
  },
  computed: {
    ...mapGetters(["getCurrentUser", "getCurrentCustomer"])
  },
  methods: {
    handleClick: async function(data, row) {
      var rowId = data.indexOf(row);
      var fleetCount;
      data[rowId].loadingStatus = true;
      // if c_dbDownloadFlag is false then below code will execute
      if (
        data[rowId].c_dbDownloadFlag == "false" &&
        (data[rowId].c_navdbType == "GE" ||
          data[rowId].c_navdbType == "CMC" ||
          data[rowId].c_navdbType == "Universal")
      ) {
        // open popup code which will display the fleet count
        await this.declaredDatabaseData();
        this.declaredDatabaseList.forEach(element => {
          if (data[rowId].c_databaseIndicator == element.c_databaseIndicator) {
            if (
              element.c_fleetCount == undefined ||
              element.c_fleetCount == ""
            ) {
              element.c_fleetCount = 0;
            }
            return (fleetCount = element.c_fleetCount);
          }
        });
        let confirmFleet = confirm(
          "Please confirm your fleet count: " + fleetCount
        );
        // once the fleet count is confirmed then download the database
        if (confirmFleet == true) {
          await downloadDatabase(
            data[rowId],
            this.getCurrentUser,
            this.getCurrentCustomer
          );
          // set the download flag as true in Joget data
          const payload = this.prepareDbFlagPayload(data[rowId].id);
          await storeData(
            process.env.VUE_APP_DATABASES_APP_ID,
            "" + process.env.VUE_APP_DELIVERED_DATABASES_FORM,
            data[rowId].id,
            payload
          )
            .then(response => {
              if (response.ok) {
                data[rowId].c_dbDownloadFlag = "true";
                console.log("Data update success");
              }
            })
            .catch(error => {
              // eslint-disable-next-line no-console
              console.error("inside error", error);
            });
        } else {
          alert(
            "Please modify the fleet count from Declared Database Section in Admin page"
          );
          store.isDownloadRequest = true;
          store.dbIdentifier = data[rowId].c_databaseIndicator;
          store.dbType = data[rowId].c_navdbType;
          router.push("admin");
        }
      } else {
        downloadDatabase(
          data[rowId],
          this.getCurrentUser,
          this.getCurrentCustomer
        );
      }
    },

    prepareDbFlagPayload(rowId) {
      const payload = [
        { id: "dbDownloadFlag", value: "true" },
        { id: "id", value: rowId }
      ];
      return payload;
    },
    downloadExtraFile: function(data, row) {
      var rowId = data.indexOf(row);
      data[rowId].loadingStatus = true;
      downloadExtraFile(data[rowId]);
    },
    downloadSha256(data, row) {
      var rowId = data.indexOf(row);
      data[rowId].loadingStatus = true;
      downloadSha256(data[rowId]);
    },

    declaredDatabaseData: async function() {
      var localThis = this;
      return fetchList(
        process.env.VUE_APP_DATABASES_APP_ID,
        "" + process.env.VUE_APP_DECLARED_DATABASES_LIST,
        process.env.VUE_APP_JOGET_DDT_FILTER_FOR_DECLARED_DB_NAME +
        "=" +
        localThis.getCurrentCustomer.name
      )
        .then(json => {
          var data = json.data;
          data.forEach(element => {
            //Add element to the list
            localThis.declaredDatabaseList.push(element);
          });
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(error);
        });
    }
  }
})
export default class Databases extends Vue {
  data() {
    return {
      fillTableActive: [],
      fillTablePending: [],
      declaredDatabaseList: []
    };
  }

  created() {
    let localThis = this;

    //Get active databases
    this.fetchDatabasesList(
      process.env.VUE_APP_ACTIVE_DATABASES_LIST,
      this.fillTableActive,
      process.env.VUE_APP_JOGET_DDT_FILTER_FOR_ACTIVE_DB_CUSTOMER,
      process.env.VUE_APP_JOGET_DDT_FILTER_FOR_ACTIVE_DB_PUBLICATION_LOC
    );

    //Get pending databases
    this.fetchDatabasesList(
      process.env.VUE_APP_INACTIVE_DATABASES_LIST,
      this.fillTablePending,
      process.env.VUE_APP_JOGET_DDT_FILTER_FOR_PENDING_DB_CUSTOMER,
      process.env.VUE_APP_JOGET_DDT_FILTER_FOR_INACTIVE_DB_PUBLICATION_LOC
    );
  }

  /**
   *Fill databasesList with the databases of the list jogetList of joget backend
   *according to the regions the customer of the current user suscribed to. It use the
   *filter of the joget backend to retrieve only the databases corresponding to current customer.
   */
  fetchDatabasesList(jogetList, databasesList, customerFilterId, publicationLocationId) {
    let localThis = this;
    fetchList(
      process.env.VUE_APP_DATABASES_APP_ID,
      "" + jogetList,
      [customerFilterId + "=" + localThis.getCurrentCustomer.id,
      publicationLocationId + "=" + process.env.VUE_APP_JOGET_DDT_PUBLICATION_CUSTOMER_PORTAL]
    )
      .then(json => {
        var data = json.data;
        data.forEach(element => {
          //Set loading property in element object
          element.loadingStatus = false;
          //Add element to the list
          if(element.c_navdbType == 'GE'){
            const dbSize = parseInt(Number(element.c_dbSize));
            const dbMaxSize = parseInt(Number(element.c_ofpMemorySize));
            if (!!dbSize && !!dbMaxSize) {
              const percent = ((dbSize / dbMaxSize) * 100).toFixed(2);
              element.c_dbSize = dbSize +'/'+ dbMaxSize + ' (' + percent + '%)';
            } else {
              element.c_dbSize = '-';
            }
          } else {
            element.c_dbSize = '-';
          }
          databasesList.push(element);
        });
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  }
}
</script>
<style lang="scss">
.databases-page {
  //display: flex;
  justify-content: center;
  //min-height: calc(100vh - var(--size-bar));
  //max-height: calc(100vh - var(--size-bar) + 12px);
  background-image: linear-gradient(#fe30540f, #1624570f);
  .databases-page__container {
    min-width: calc(var(--unit) * 65);
    box-shadow: 0 8px 20px 0 rgba(25, 25, 25, 0.2);
    overflow: scroll;
    .databases-header {
      background-color: white;
      height: calc(var(--unit) * 4);
      display: flex;
      align-items: center;
      .databases-title {
        font-size: calc(var(--unit) * 1.5);
        font-weight: 700;
        color: #333;
        margin-left: calc(var(--unit) * 2);
        .nb-icon {
          margin-right: var(--unit);
        }
      }
    }
  }
}
.databases-content {
  background-color: #ebebeb;
  padding: calc(var(--unit) * 2);
  .databases_title {
    margin-bottom: calc(var(--unit) * 2);
    font-size: var(--unit);
    color: var(--color-black4);
    display: flex;
    align-items: center;
    .nb-icon {
      margin-right: calc(var(--unit) * 0.75);
    }
  }
}
</style>
